export interface DatasetProfileDto {
  id: string;
  version: number;
  profileName: string;
  intendedPurpose?: string[];
  owningOrganizationId?: number;
  [key: string]: unknown;
}

export const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';
export const MINIMUM_REQUIREMENTS: Record<string, string[]> = {
  system: ['productName', 'articleNumber', 'gtin'],
  unit: ['productName', 'category', 'articleNumber', 'gtin', 'packagingLevel', 'fillingGoodProductRange', 'fillingGoodProductCategory'],
  component: ['packagingComponentType', 'articleNumber', 'gtin', 'hasDirectContactWithProduct', 'isRigidComponent'],
  multiMaterial: ['articleName', 'articleNumber', 'gtin', 'layerMaterial', 'layerMaterialFunction', 'layerMass'],
};

export function createDefaultPackagingComponentProfile(): DatasetProfileDto {
  return {
    id: EMPTY_GUID,
    version: 0,
    profileName: '',
    multiMaterialProfileId: null,
    data: {
      packagingComponentType: true,
      articleName: true,
      articleNumber: true,
      manufacturer: true,
      printingCoverage: true,
      totalWeight: true,
      manufacturingLocation: true,
      length: true,
      width: true,
      height: true,
      isRigidComponent: true,
      containsNearInfraredBarrier: true,
      gtin: true,
      distributionLocations: true,
      images: true,
      documents: true,
      certificates: true,
      tags: true,
      hasDirectContactWithProduct: true,
      surfaceRatio: true,
      isAdhesiveUsed: true,
      removedByConsumer: true,
      removedBeforeUsage: true,
      separationThroughCollectionAndSorting: true,
      removabilityCondition: true,
      isPhysicallyAttached: true,
      excludedEvidenceTypes: [],
    },
  };
}

export function createDefaultMultiMaterialProfile(): DatasetProfileDto {
  return {
    id: EMPTY_GUID,
    version: 0,
    profileName: '',
    data: {
      articleNumber: true,
      articleName: true,
      gtin: true,
      manufacturerName: true,
      manufacturingLocation: true,
      layers: true,
      layerMaterialFunction: true,
      layerMaterial: true,
      layerColor: true,
      layerMass: true,
      layerThickness: true,
      layerGrammage: true,
      layerDensity: true,
      layerRecyclingMaterialPercentage: true,
      layerManufacturingProcess: true,
      excludedEvidenceTypes: [],
    },
  };
}

export function createDefaultPackagingUnitProfile(): DatasetProfileDto {
  return {
    id: EMPTY_GUID,
    version: 0,
    profileName: '',
    brandName: true,
    productName: true,
    category: true,
    articleNumber: true,
    gtin: true,
    packagingQuantity: true,
    packagingLevel: true,
    packagingVolume: true,
    length: true,
    width: true,
    height: true,
    distributionLocations: true,
    fillingGoodProductRange: true,
    fillingGoodProductCategory: true,
    excludedEvidenceTypes: [],
    packagingComponentProfileId: null,
    multiMaterialProfileId: null,
  };
}

export function createDefaultPackagingSystemProfile(): DatasetProfileDto {
  return {
    id: EMPTY_GUID,
    version: 0,
    profileName: '',
    brandName: true,
    productName: true,
    articleNumber: true,
    length: true,
    width: true,
    height: true,
    gtin: true,
    distributionLocations: true,
    excludedEvidenceTypes: [],
    subPackagingSystems: { quantity: true, childPackagingSystem: true },
    packagingUnits: { quantity: true },
    childPackagingUnitProfileId: null,
  };
}
